import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import { NavButton } from 'components/Button'
import HTMLReactParser from 'html-react-parser'
import { returnCodeToBr } from 'lib/helper'
import { Description } from 'components/Typography'

type Props = {
  description?: string
  iconPath: string
  label: string
  backToTop: () => void
}

const CompleteTemplate: FC<Props> = (props) => {
  const { description, iconPath, label, backToTop } = props

  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={iconPath} alt={label} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>{HTMLReactParser(returnCodeToBr(label))}</h2>
        {description && (
          <>
            <Spacer size={16} />
            <Description description={description} />
          </>
        )}
      </FlexColumn>
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} onClick={backToTop} url={''} />
      <Spacer size={72} />
    </div>
  )
}

export default CompleteTemplate
